import { Trans } from "@lingui/react/macro";
import { LockIcon } from "lucide-react";
import { useId } from "react";

import { Button } from "@/shared/ui/button";

// Steam: «Редактировать профиль» → «Приватность».
const STEAM_PRIVACY_URL = "https://steamcommunity.com/my/edit/settings";

type PrivateListNoticeProps = {
  onRefresh: () => void;
  // Проверка уже идёт: кнопка ждёт ответа.
  checking: boolean;
};

// Список друзей в Steam закрыт: как его открыть и кнопка проверить снова.
export const PrivateListNotice = ({ onRefresh, checking }: PrivateListNoticeProps) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className="flex flex-wrap items-center gap-x-5 gap-y-3.5 rounded-xl border border-bad/50 bg-surface-raised px-5 py-4.5"
    >
      <LockIcon aria-hidden="true" className="size-7 text-bad" />
      <div className="flex flex-[1_1_380px] flex-col gap-1">
        <h2 id={headingId} className="text-lg font-semibold">
          <Trans>Your Steam friend list is hidden</Trans>
        </h2>
        <p className="text-sm text-muted">
          <Trans>
            Without it we can't tell which friends are already on Relock. Open it: Steam profile →
            Edit profile → Privacy settings → “Friends list: Public”. Party mates are shown anyway.
          </Trans>
        </p>
      </div>
      <div className="flex flex-wrap gap-2.5">
        <Button asChild className="min-h-11">
          <a href={STEAM_PRIVACY_URL} target="_blank" rel="noreferrer">
            <Trans>Steam settings</Trans>
          </a>
        </Button>
        <Button variant="outline" className="min-h-11" loading={checking} onClick={onRefresh}>
          {checking ? <Trans>Checking…</Trans> : <Trans>Check again</Trans>}
        </Button>
      </div>
    </section>
  );
};
